<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import HeaderHelperLinks from '@/components/Moleculas/HeaderHelperLinks.vue'
const store = useStore()

const playoutConfig = computed(() => store.getters['Playout/playoutConfig'])

</script>

<template>
  <header class="p-4 flex items-center border-b border-surface-2">
    <div>
      <h2 class="capitalize text-lg font-medium mb-2">{{ playoutConfig?.mode }}</h2>
      <HeaderHelperLinks howItWorksLink="https://docs.castr.com/en/articles/8001118-create-your-tv-playout" howItWorksText="How TV Playout works" tutorialLink="cly4943mk0e93mb30nkdztonp" />
    </div>
  </header>
</template>
<style scoped></style>
